import React, { Component } from "react";
import { Card, CardHeader, CardBody, UncontrolledAlert } from "reactstrap";
import DataTable from "../../Shared/DataTable";
import { MdDelete, MdSearch, MdModeEdit } from "react-icons/md"; 

export class MerchantTable extends Component {
  render() {
    const columns = [
      {
        Header: "Name",
        accessor: "name"
      },
      {
        Header: "Address",
        accessor: "address"
      },
      {
        Header: "Merchant URL",
        accessor: "url"
      }
    ];

    const {
      match,
      fetching,
      data,
      error,
      filterData,
      selectRow,
      pages,
      page,
      pageSize,
      deleteRow,
      showModal,
      setPageNumber,
      setPageSize
    } = this.props;

    const actions = [
      {
        name: "edit",
        btnText: "",
        btnAction: selectRow,
        btnClass: "btn-primary",
        btnIcon: MdModeEdit,
        tooltip: "Edit"
      },
      {
        name: "view",
        btnText: "",
        btnAction: selectRow,
        btnClass: "btn-success",
        btnIcon: MdSearch,
        tooltip: "View"
      },
      {
        name: "cancel",
        btnText: "",
        btnAction: showModal,
        btnClass: "btn-danger",
        btnIcon: MdDelete,
        hiddenParam: "hasPassed",
        tooltip: "Delete"
      }
    ];

    return (
      <div>
        <Card className="pp4">
          <CardHeader>Merchants</CardHeader>
          <CardBody>
            {error && (
              <UncontrolledAlert color="danger">
                {error.message}
              </UncontrolledAlert>
            )}
            <DataTable
              columns={columns}
              loading={fetching}
              manual={true}
              pages={pages}
              page={page}
              pageSize={pageSize}
              urlParams={match}
              data={data ? data.data : []}
              count={data ? data.count : 0}
              defaultPageSize={10}
              deleteRow={deleteRow}
              selectRow={selectRow}
              showModal={showModal}
              filterData={filterData}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              searchParam="searchKey"
              hideSearchParam={true}
              actions={actions}
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default MerchantTable;
